<template>
  <Modal :show="show" role="alertdialog" size="8xl" :use-focus-trap="false" inlineClass="z-[70]">
    <form
      @submit.prevent="handleConfirm"
      class="mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
    >
      <slot>
        <div class="text-center text-3xl font-bold text-yellow-600 bg-yellow-100 dark:bg-yellow-900 dark:text-yellow-300 py-4 px-6 border-b-4 border-yellow-500">
          List of Outstanding Cores Older Than 5 Days
        </div>
        <ModalContent style="max-height: 600px; overflow: auto">
          <ResourceIndex
            ref="resourceIndex"
            :resource-name="'order-products'"
            :simpleTableListing="true"
            :shouldOverrideMeta="true"
            :shouldEnableShortcut="true"
          />
        </ModalContent>
      </slot>

      <ModalFooter>
        <div class="ml-auto">
            <Button
                @click.stop="handleConfirm"
                ref="confirmButton"
                dusk="confirm-delete-button"
                :disabled="isLoading"
                state="default"
                :label="'Close'"
            />
        </div>
      </ModalFooter>
    </form>
  </Modal>
</template>

<script>
import { Button } from 'laravel-nova-ui'
import {mapGetters} from "vuex";
export default {
    components: {
        Button,
    },
  emits: ['confirm', 'close'],

  props: {
    show: { type: Boolean, default: false },
  },
  data() {
    return {
      isLoading: true,
    }
  },
  watch: {
    show(newValue) {
      // Reset loading state when modal is opened
      if (newValue) {
        this.isLoading = true
      }
    },
  },
  mounted() {
    // Listen for resources-loaded event from ResourceIndex
    Nova.$on('resources-loaded', this.handleResourcesLoaded)
  },
  beforeUnmount() {
    Nova.$off('resources-loaded', this.handleResourcesLoaded)
  },
  methods: {
    handleConfirm() {
        this.$emit('confirm')
    },
    handleResourcesLoaded(event) {
      // Check if this is for our resource (order-products)
      if (event.resourceName === 'order-products') {
        this.isLoading = false
      }
    },
  },
}
</script>
